/*
@since: 2023-8-16
@author: Mohammad Traboulsi
@maintainer: Mohammad Traboulsi
@copyright: AlgoTraders, All rights reserved
*/

import ResetPassword from "./ResetPassword";
export default ResetPassword;
